import { OldEmitterConfig} from "pixi-particles";

export class ParticleSettings{

    public static readonly float:OldEmitterConfig = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.3,
            "end": .3,
            "minimumScaleMultiplier": 1.4
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 120,
            "end": 120,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 1,
        "startRotation": {
            "min": 270,
            "max": 270
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": 0,
            "max": 0
        },
        "lifetime": {
            "min": 20,
            "max": 20
        },
        "blendMode": "add",
        "frequency": 0.25,
        "emitterLifetime": -1,
        "maxParticles": 100,
        "pos": {
            "x": -360,
            "y": 0
        },
        "addAtBack": true,
        "spawnType": "rect",
        "spawnRect": {
            "x": 360,
            "y": 1000,
            "w": 800,
            "h": 0
        }
    }

    public static readonly Fountain:OldEmitterConfig =
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.6,
                "end" : 0.4,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 700,
                "end" : 350,
                "minimumSpeedMultiplier" : 2
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1500
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 235,
                "max" : 310
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 10,
                "max" : 70
            },
            "lifetime" : {
                "min" : 5,
                "max" : 5
            },
            "blendMode" : "normal",
            "frequency" : 0.1,
            "emitterLifetime" : -1,
            "maxParticles" : 50,
            "pos" : {
                "x" : 1280/2,
                "y" : 760,
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -380,
                "y" : -25,
                "w" : 200,
                "h" : 50
            }
        }

        public static readonly SplashMiddle:OldEmitterConfig =
        {
            "alpha": {
                "start": 1,
                "end": 0
            },
            "scale": {
                "start": 0.2,
                "end": 0.5,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 120,
                "end": 40,
                "minimumSpeedMultiplier": 5
            },
            "acceleration": {
                "x": 0,
                "y": 0
            },
            "maxSpeed": 20,
            "startRotation": {
                "min": 30,
                "max": 360
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 0,
                "max": 20
            },
            "lifetime": {
                "min": 1,
                "max": 2
            },
            "blendMode": "normal",
            "frequency": 0.001,
            "emitterLifetime": 0.5,
            "maxParticles": 20,
            "pos": {
                "x": 360,
                "y": 300
            },
            "addAtBack": true,
            "spawnType": "point"
        };

    public static readonly Fountain_Splash:OldEmitterConfig =
        {
            "alpha" : {
                "start" : 1,
                "end" : 1
            },
            "scale" : {
                "start" : 0.6,
                "end" : 0.4,
                "minimumScaleMultiplier" : 1
            },
            "color" : {
                "start" : "#ffffff",
                "end" : "#ffffff"
            },
            "speed" : {
                "start" : 700,
                "end" : 350,
                "minimumSpeedMultiplier" : 2
            },
            "acceleration" : {
                "x" : 0,
                "y" : 1500
            },
            "maxSpeed" : 0,
            "startRotation" : {
                "min" : 235,
                "max" : 310
            },
            "noRotation" : false,
            "rotationSpeed" : {
                "min" : 10,
                "max" : 70
            },
            "lifetime" : {
                "min" : 5,
                "max" : 5
            },
            "blendMode" : "normal",
            "frequency" : 0.001,
            "emitterLifetime" : 0.5,
            "maxParticles" : 50,
            "pos" : {
                "x" : 1280/2,
                "y" : 680,
            },
            "addAtBack" : false,
            "spawnType" : "rect",
            "spawnRect" : {
                "x" : -380,
                "y" : -25,
                "w" : 200,
                "h" : 50
            }
        }
}